@if (list.length > 0) {
  <div class="vacation-packages-list">
    <div id="show-list" class="packages-list-new">
      @for (pkg of list; track pkg.name) {
        <div class="item shadow-block white-block">
          <div class="item-up">
            <div class="row">
              <div class="col-sm-9 mb-2">
                <div class="name">
                  <a href="#" (click)="$event.preventDefault()">{{ pkg.name }}</a>
                </div>
              </div>
              <div class="col-sm-3 mb-2">
                @if (pkg.saveUpTo != null) {
                  <div class="save w-100 text-center">
                    Save up to ${{ pkg.saveUpTo | number: '1.2-2' }}
                  </div>
                }
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-sm-4">
                <div class="gray">
                  <span class="icon ib-calender fs-6 gray"></span>
                  <small>Available Dates:</small>
                </div>
                <div class="ms-4">
                  <small
                    >{{ pkg.startDate }}
                    @if (pkg.endDate) {
                      - {{ pkg.endDate }}
                    }
                  </small>
                </div>
              </div>
              <div class="col-sm-8"></div>
            </div>
            @if (pkg.descriptionHtml) {
              <div class="description mb-3" [innerHTML]="pkg.descriptionHtml"></div>
            }
          </div>
          <div class="row">
            <div class="col-sm-9">
              <div class="items-in row">
                @for (item of pkg.items; track item.name) {
                  <div class="col-12 col-sm-6 col-md-4">
                    <a href="#" (click)="$event.preventDefault()">
                      @if (item.image) {
                        <img [src]="item.image" [alt]="item.name" />
                      }
                      <span>{{ item.name }}</span>
                    </a>
                  </div>
                }
              </div>
            </div>
            <div class="col-sm-3">
              <div>
                <a
                  href="#"
                  class="btn btn-primary w-100 ps-0 pe-0"
                  (click)="$event.preventDefault()"
                  >Buy Package</a
                >
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  </div>
}
